import { UseMutationOptions, UseMutationResult, useMutation } from "@tanstack/react-query";
import { IPostActionParams, postAction } from "../actions/sector-workflow.actions";

export interface IUsePostMutationParams<TResponse, TBody> {
  mutationOptions?: UseMutationOptions<TResponse, Error, IPostActionParams<TBody>>;
}

export const usePostMutation = <TResponse, TBody = unknown>(
  params?: IUsePostMutationParams<TResponse, TBody>,
): UseMutationResult<TResponse, Error, IPostActionParams<TBody>> => {
  const { mutationOptions } = params ?? {};

  return useMutation<TResponse, Error, IPostActionParams<TBody>>({
    mutationFn: async (mutationParams) => {
      return postAction<TResponse, TBody>(mutationParams);
    },
    ...mutationOptions,
  });
};
